module.exports = __webpack_public_path__ + "static/img/Horticulturae 08.83761c6c.webp";